import useAsyncFn from 'react-use/lib/useAsyncFn';

export type HubspotField = {
  objectTypeId?: string;
  name: string;
  value: string;
};

export type HubspotConsent = {
  consentToProcess: boolean;
  text: string;
  communications: Array<{
    value: boolean;
    subscriptionTypeId: number;
    text: string;
  }>;
};

const HUBSPOT_PORTAL_ID = '21894833';

export const useHubspotForm = ({
  formId,
  pageName,
}: {
  formId: string;
  pageName: string;
}) => {
  return useAsyncFn(
    async (fields: HubspotField[], consent?: HubspotConsent) => {
      const body: Record<string, unknown> = {
        submittedAt: new Date().getTime(),
        fields,
        context: {
          pageUri: `${window.location.origin}${window.location.pathname}`,
          pageName,
        },
      };

      if (consent) {
        body.legalConsentOptions = { consent };
      }

      const response = await fetch(
        `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${formId}`,
        {
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        },
      );

      if (!response.ok) {
        throw new Error('Submission failed');
      }

      return response;
    },
  );
};
